export default function validateKucoin(uid) {
  let error = "";
  let regex = /^\d{9,11}$/; // Only digits, length between 9 and 11

  if (!uid) {
    error = "UID is required";
  } else if (!regex.test(uid)) {
    error = "This is not a valid UID";
  }

  return error;
}
